module.exports = __webpack_public_path__ + "static/img/index-logo.cdde65d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/index-logo.png
// module id = qlU9
// module chunks = 1